import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isGoFatafatEnabled } from "../../../utils/companyCapabilities";
import {
  getReportPermissions,
  hasReportRouteAccess,
} from "../../../utils/permissions";

const GOFATAFAT_REPORT_LINKS = [
  {
    to: "/report/restaurantPerformance",
    label: "Restaurant Performance",
  },
  {
    to: "/report/marketplaceOrderEarningsReport",
    label: "Orders Report",
  },
  {
    to: "/report/marketplaceSettlementReport",
    label: "Settlements",
  },
];

const GoFatafatSidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  const profileData = useSelector((state) => state.auth.profileData);
  const user = useSelector((state) => state.auth.user);
  const userForPerms =
    user && profileData && !user.profileData
      ? { ...user, profileData }
      : user;

  if (!isGoFatafatEnabled(profileData)) {
    return null;
  }

  const reportPermissions = getReportPermissions(userForPerms);
  const visibleReports = GOFATAFAT_REPORT_LINKS.filter((link) => {
    if (!reportPermissions.canAccessReports) return false;
    return hasReportRouteAccess(userForPerms, link.to);
  });

  const isGoFatafatRoute =
    currentPath.startsWith("/gofatafat") ||
    currentPath.startsWith("/report/restaurantperformance") ||
    currentPath.startsWith("/report/marketplaceorderearningsreport") ||
    currentPath.startsWith("/report/marketplacesettlementreport");

  return (
    <div className={`menu-item has-sub ${isGoFatafatRoute ? "active" : ""}`}>
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-motorcycle"></i>
        </div>
        <div className="menu-text">Go Fatafat</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${
            currentPath === "/gofatafat/settings" || currentPath === "/gofatafat"
              ? "active"
              : ""
          }`}
        >
          <NavLink to="/gofatafat/settings" className="menu-link">
            Settings
          </NavLink>
        </div>
        <div
          className={`menu-item ${
            currentPath.startsWith("/gofatafat/campaigns") ? "active" : ""
          }`}
        >
          <NavLink to="/gofatafat/campaigns" className="menu-link">
            Campaigns
          </NavLink>
        </div>
        {visibleReports.map((link) => (
          <div
            key={link.to}
            className={`menu-item ${
              location.pathname.toLowerCase().startsWith(link.to.toLowerCase())
                ? "active"
                : ""
            }`}
          >
            <NavLink to={link.to} className="menu-link">
              {link.label}
            </NavLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoFatafatSidebar;
